<template>
    <div ref="content" style="width: 100%;height:100%;position: relative">
        <div class="search" style="position: relative;height: 50px;z-index: 10;background: #f5f5f5">
            <div style="position:absolute;height:30px;left: 10px;right: 10px;top:10px;">
                <input v-model="search" style="width: 100%;height:30px;text-indent: 5px" placeholder="输入搜索信息"/>
            </div>
            <img @click="loadTop" style="position: absolute;top:15px;bottom:0;padding-left:5px;margin: 0;right:15px"
                 src="../assets/img/search.svg"/>
        </div>
        <div class="border-line"></div>
        <div :style="'height:'+height+'px'">
            <mt-loadmore :bottomDropText="options.bottomDropText" :bottomPullText="options.bottomPullText"
                         :top-method="loadTop" :bottom-method="loadBottom"
                         :bottom-all-loaded="!options.hasMore"
                         ref="loadmore">
                <div class="list">
                    <div v-for="item in list" class="list-item space-between" @click="viewDetail(item)">
                        <div class="icon">
                            <img :src="item.imgUrl || '../assets/img/v2_ptfzn1.png'"/>
                        </div>
                        <div style="margin-left: 10px;flex:1;">
                            <div class="space-between">
                                <div style="flex:1;font-size:15px">{{item.name}}</div>
                                <div style="font-size:15px">{{item.price}}</div>
                                <img src="../assets/img/next.svg"/>
                            </div>
                            <div style="color:#888">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="border-line"></div>
                </div>
            </mt-loadmore>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator} from 'mint-ui';

    export default {
        data() {
            return {
                height: 0,
                search: "",
                options: {
                    currentPage: 1,
                    pageSize: 10,
                    hasMore: false,
                    bottomDropText: "释放加载",
                    bottomPullText: "加载更多",
                },
                list: []
            }
        },
        methods: {
            loadTop: function () {
                this.options.currentPage = 1;
                this.loadList((res) => {
                    this.$refs.loadmore.onTopLoaded();
                });
            },
            loadBottom: function () {
                this.options.loading = true;
                this.options.currentPage++;
                this.loadList((res) => {
                    this.$refs.loadmore.onBottomLoaded();
                });
            },
            loadList: function (onload) {
                Indicator.open('加载中...');
                window.Indicator = Indicator;
                api.getFormUrl(this, "yy/front/getProductList", {
                    pageNo: this.options.currentPage,
                    pageSize: 15,
                    keyWord: this.search
                }, (res) => {
                    if (this.options.currentPage == 1) {
                        this.list = [];
                    }
                    this.list = this.list.concat(res.data || [])
                    if (res.total <= res.pageNo * res.pageSize) {
                        this.options.hasMore = false;
                        if (this.list.length) {
                            this.options.bottomPullText = "没有更多了";
                        } else {
                            this.options.bottomPullText = "没有数据";
                        }
                    } else {
                        this.options.hasMore = true;
                        this.options.bottomPullText = "加载更多";
                    }
                    onload(res);
                    Indicator.close();
                }, () => {
                    Indicator.close();
                })
            },
            viewDetail: function (item) {
                this.$store.commit('set', {
                    transData: item
                });
                this.$router.push({
                    path: '/treatmentDetail',
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            }
        },
        mounted() {
            this.height = this.$refs.content.height - 50;
        }
    }

</script>

<style lang="scss">
    @import "../assets/styles/common.css";

    .icon {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        box-shadow: 0 0 2px rgba(0, 0, 0, .5);
        box-sizing: border-box;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }
</style>